<template>
    <div class="contact">
        <nav-head :bg="false"></nav-head>
        <div class="ban-bg">
            <img src="~assets/images/about/txt-con.png">
        </div>
        <div class="con-way">
            <div class="con-wrap">
                <div class="qr-code">
                    <img src="~assets/images/home/2_06.png?v1">
                    <p>保存截图</p>
                    <p>微信扫一扫添加客服</p>
                </div>
                <div class="way-bg">
                    <div class="call" style="display: none;">
                        <img src="~assets/images/about/way-qq.png">
                        <div>
                            <p>招商QQ</p>
                            <p>1432144275</p>
                        </div>
                    </div>
                    <div class="call">
                        <img src="~assets/images/about/way.png">
                        <div>
                            <p>招商热线</p>
                            <p>183 7426 3470</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <input-wrap id="info"></input-wrap>
        <back-top></back-top>
        <footer-version></footer-version>
    </div>
</template>

<script>
    import {NavHead,FooterVersion,InputWrap,BackTop} from "../components";
    import {linkRefresh} from "../common/mixin";

    export default {
        name: "Contact",
        components: {
            NavHead,
            FooterVersion,
            InputWrap,
            BackTop
        },
        mixins:[linkRefresh]
    }
</script>

<style scoped lang="less">
    .ban-bg {
        background-image: url("~assets/images/about/ban-con.jpg");
        img {
            height: 74px;
        }
    }
    .con-way {
        height: 340px;
        background: #fff;
        position: relative;
        padding: 0 30px;
        color:#0d4e92;
        .con-wrap {
            display: flex;
            align-items: center;
            height: 356px;
            position: absolute;
            width: 92%;
            box-sizing: border-box;
            top: -40px;
            box-shadow: 0 0 5px rgba(0,0,0,.2);
            .qr-code {
                text-align: center;
                background: #fff;
                width: 40%;
                height: 100%;
                display: flex;
                flex-flow: column;
                justify-content: center;
                align-items: center;
                img {
                    height: 190px;
                    padding: 5px;
                    outline: 1px solid #648eba;
                    margin-bottom: 20px;
                }
                p{
                    font-size: 20px;
                }
            }
            .way-bg {
                background: url("~assets/images/about/way-bg.png") no-repeat center/100% 100%;
                flex: 1;
                height: 100%;
                display: flex;
                flex-flow: column;
                justify-content: center;
                align-items: center;
                .call {
                    display: flex;
                    align-items: center;
                    padding: 40px 0;
                    img {
                        height: 68px;
                    }
                    div {
                        flex: 1;
                        padding-left: 25px;
                        width: 190px;
                        p{
                            &:first-child {
                                font-size: 20px;
                            }
                            &:last-child {
                                font-size: 24px;
                                font-weight: bold;
                            }
                        }
                    }
                }

            }
        }
    }

</style>